import React, { useEffect, useRef } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { toast } from '../../components/common/Toast/toast';
import { useAuth } from "../../../context/AuthContext.js";
import "./classroomApp.css";
import AppNav from "./components/AppNav.jsx";
import DashboardTab from "./tabs/DashboardTab/DashboardTab.jsx";
import BookingsTab from "./tabs/BookingsTab/BookingsTab.jsx";
import LabsTab from "./tabs/LabsTab/LabsTab.jsx";
import TrainersTab from "./tabs/TrainersTab/TrainersTab.jsx";
import ShiftsOverridesTab from "./tabs/ShiftsOverridesTab/ShiftsOverridesTab.jsx";
import ReportsTab from "./tabs/ReportsTab/ReportsTab.jsx";

const ClassroomApp = () => {
  const { hasPermission, isInitialized, loading } = useAuth();
  const navigate = useNavigate();
  const hasShownToast = useRef(false);
  const allowed = hasPermission("classroom-management", "view", "lms");

  useEffect(() => {
    if (!isInitialized || loading) return;
    if (!allowed && !hasShownToast.current) {
      hasShownToast.current = true;
      toast.error("You do not have permission to view Classroom Management.");
      navigate("/");
    }
  }, [allowed, isInitialized, loading, navigate]);

  if (!isInitialized || loading || !allowed) {
    return null;
  }

  return (
    /* .cls-app still carries the app's own tokens, which the tabs that
       have not been converted yet still read. It loses them as each one
       moves across; the shell, the nav and the shared components are on
       the kit already. */
    <div className="cls-app">
      <AppNav />
      <div className="cls-body">
        <Routes>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<DashboardTab />} />
          <Route path="bookings" element={<BookingsTab />} />
          <Route path="labs" element={<LabsTab />} />
          <Route path="trainers" element={<TrainersTab />} />
          <Route path="shifts" element={<ShiftsOverridesTab />} />
          <Route path="reports" element={<ReportsTab />} />
          <Route path="*" element={<Navigate to="dashboard" replace />} />
        </Routes>
      </div>
    </div>
  );
};

export default ClassroomApp;
